import React, {useState} from "react";
import {CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon} from "@mui/icons-material";
import {Autocomplete, Checkbox, Chip, Divider, Grid, TextField} from "@mui/material";
import {useMst} from "../../../../../mobx";
import {observer} from "mobx-react-lite";
import {Controller, useFormContext} from "react-hook-form";
import {IQuestionForm, SubquestionForm} from "../../../QuestionForm";

interface QuestionAutocompleteSkillsProps {
  prefix?: string
}

export default observer(function QuestionAutocompleteSkills({ prefix }: QuestionAutocompleteSkillsProps) {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const { skillsStore } = useMst();
    const [loading, setLoading] = useState(false);
    const { getSkills, getSkillsData } = skillsStore;
    const { control } = useFormContext<IQuestionForm | SubquestionForm>();

    const onOpen = async () => {
        setLoading(true);
        await getSkills()
        setLoading(false);
    }

  return (
      <Controller
          control={control}
          name={`${prefix}skills`}
          defaultValue={[]}
          render={({ field: { value , onChange }}) => (
              <Autocomplete
                  value={value}
                  onChange={(_, value) => onChange(value)}
                  multiple
                  fullWidth
                  loading={loading}
                  loadingText={"Загрузка..."}
                  noOptionsText={"Нет опций"}
                  onOpen={onOpen}
                  disableCloseOnSelect
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          variant="outlined"
                          margin={"dense"}
                          size={"small"}
                          label={"Навыки"}
                          placeholder={"Выберите навык"}
                      />
                  )}
                  getOptionLabel={(option) => option.title}
                  renderTags={(values, getTagProps) =>
                      values.map((value, i) =>
                          <Chip color={"primary"} size={"small"} variant={"outlined"} label={value.title} {...getTagProps({ index: i })} />)
                  }
                  renderOption={(props, option, { selected }) => (
                      <li {...props} key={option.title + option.id}>
                          <Grid container wrap={"nowrap"} alignItems={"center"}>
                              <Grid item>
                                  <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
                              </Grid>
                              <Grid item>
                                  {option.title}
                              </Grid>
                          </Grid>
                          <Divider sx={theme => ({ margin: theme.spacing(1, 0) })}/>
                      </li>
                  )}
                  options={getSkillsData}
              />
          )}
      />
  );
});
